import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import logoDark from '../assets/images/logo.png';

import {
  Button,
  Col,
  Container,
  Row,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';
import Search from '../Components/Common/Search';
import { useDispatch, useSelector } from 'react-redux';
import { userLogoutAction } from '../actions/user/action';
import DashboardSwitcher from '../pages/Organization/DashboardSwitcher';
import { useParams } from 'react-router-dom';

const Header = ({ headerClass, theme }) => {
  const dispatch = useDispatch();
  const { campaignTypes } = useSelector((state) => state?.organization);
  const [selectedCampaignType, setSelectedCampaignType] = useState(null);
  const { campaignTypeId } = useParams();
  const { user } = useSelector((state) => state?.user || {});

  useEffect(() => {
    try {
      const newCampaignTypeId = campaignTypeId
        ?.toUpperCase()
        ?.replaceAll('-', '_');

      const selectedType = campaignTypes?.find(
        (type) => type?.campaignTypeId === newCampaignTypeId
      );

      if (selectedType?.campaignTypeId) {
        setSelectedCampaignType(selectedType);
      } else {
        setSelectedCampaignType(campaignTypes?.[0]);
      }
    } catch (e) {
      console.log(e);
    }
  }, [campaignTypeId, campaignTypes]);

  return (
    <React.Fragment>
      <header id="page-topbar" className={`py-3 ${headerClass}`}>
        <Container fluid>
          <Row>
            <Col className="d-flex align-items-center gap-3">
              <div className="navbar-brand-box horizontal-logo">
                <Link
                  to="/"
                  className={`logo ${
                    theme === 'dark' ? 'logo-light' : 'logo-dark'
                  }`}
                >
                  <img
                    src={theme === 'dark' ? logoDark : logoDark}
                    alt="large logo"
                    height="18"
                  />
                </Link>
              </div>
              <div className="d-flex gap-2 topNav">
                {campaignTypes?.length > 0 ? (
                  <UncontrolledDropdown>
                    <DropdownToggle
                      caret
                      color="light"
                      className="px-2 d-flex align-items-center gap-1 fs-14 rounded-3 shadow-none"
                    >
                      <i className="mdi mdi-puzzle-outline fs-18"></i>
                      {selectedCampaignType
                        ? `${selectedCampaignType?.name} Campaigns`
                        : 'Campaigns'}
                    </DropdownToggle>
                    <DropdownMenu>
                      {campaignTypes?.map((campaignType) => (
                        <DropdownItem
                          key={campaignType?._id || campaignType?.name}
                          tag={Link}
                          to={`/promotions/${campaignType?.campaignTypeId
                            ?.toLowerCase()
                            ?.replaceAll('_', '-')}/list`}
                          className="d-flex align-items-center gap-1 fs-14"
                          onClick={() => setSelectedCampaignType(campaignType)}
                        >
                          {`${campaignType?.name} Campaigns`}
                        </DropdownItem>
                      ))}
                    </DropdownMenu>
                  </UncontrolledDropdown>
                ) : null}

                <Link
                  to="/members/list"
                  className="px-2 d-flex align-items-center gap-1 fs-14 rounded-3"
                >
                  <i className="ri-group-line fs-18"></i> Members
                </Link>
                <Link
                  to="/currencies/alhan/dashboard"
                  className="px-2 d-flex align-items-center gap-1 fs-14 rounded-3"
                >
                  <i className="ri-trophy-line fs-18"></i> Rewards
                </Link>
                <Link
                  to="#"
                  className="px-2 d-flex align-items-center gap-1 fs-14 rounded-3"
                >
                  <i className="ri-wallet-line fs-18"></i> Wallets
                </Link>
                <Link
                  to="#"
                  className="px-2 d-flex align-items-center gap-1 fs-14 rounded-3"
                >
                  <i className="mdi mdi-puzzle-outline fs-18"></i>Gift Cards
                </Link>
                <Link
                  to="#"
                  className="px-2 d-flex align-items-center gap-1 fs-14 rounded-3"
                >
                  <i className="mdi mdi-puzzle-outline fs-18"></i>Vouchers
                </Link>
              </div>
            </Col>
            <Col>
              <div className="d-flex gap-2 align-items-center justify-content-end topNavEnd">
                <DashboardSwitcher />
                <Search />
                <UncontrolledDropdown group>
                  <DropdownToggle
                    size="sm"
                    color="light"
                    className="d-flex justify-content-center align-items-center rounded-3"
                  >
                    <i className="bx bx-help-circle fs-18"></i>
                  </DropdownToggle>
                  <DropdownMenu>
                    <DropdownItem header className="text-muted fs-11">
                      Header asdfasd
                    </DropdownItem>
                    <DropdownItem className="fs-14">Usage</DropdownItem>
                    <DropdownItem text className="text-muted fs-11">
                      Dropdown Item Text
                    </DropdownItem>
                    <DropdownItem disabled className="fs-14">
                      Action (disabled)
                    </DropdownItem>
                    <DropdownItem divider />
                    <DropdownItem className="fs-14">Foo Action</DropdownItem>
                    <DropdownItem className="fs-14">Bar Action</DropdownItem>
                    <DropdownItem className="fs-14">
                      <Link to="/organization/manage">Organization Setup</Link>
                    </DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>
                <Button
                  size="sm"
                  color="light"
                  className="d-flex justify-content-center align-items-center"
                >
                  <i className="bx bx-book-open fs-18"></i>
                </Button>
                <UncontrolledDropdown group>
                  <DropdownToggle
                    size="sm"
                    color="light"
                    className="d-flex justify-content-center align-items-center rounded-3"
                  >
                    <i className="bx bx-cog fs-18"></i>
                  </DropdownToggle>
                  <DropdownMenu>
                    <DropdownItem header className="text-muted fs-11">
                      Header
                    </DropdownItem>
                    <DropdownItem className="fs-14">Some Action</DropdownItem>
                    <DropdownItem text className="text-muted fs-11">
                      Dropdown Item Text
                    </DropdownItem>
                    <DropdownItem disabled className="fs-14">
                      Action (disabled)
                    </DropdownItem>
                    <DropdownItem divider />
                    <DropdownItem className="fs-14">Foo Action</DropdownItem>
                    <DropdownItem className="fs-14">Bar Action</DropdownItem>
                    <DropdownItem className="fs-14">
                      <Link to="/organization/manage">Organization</Link>
                    </DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>

                <UncontrolledDropdown group>
                  <DropdownToggle
                    size="sm"
                    color="soft-dark"
                    className="d-flex justify-content-center align-items-center rounded-circle position-relative"
                    style={{ width: '36px', height: '36px' }}
                  >
                    {user?._id && (
                      <span>{`${user?.firstName?.[0]}${user?.lastName?.[0]}`}</span>
                    )}
                  </DropdownToggle>
                  <DropdownMenu>
                    <DropdownItem header className="text-muted fs-11">
                      Welcome{user?.firstName}
                    </DropdownItem>
                    <DropdownItem className="fs-14">Some Action</DropdownItem>
                    <DropdownItem text className="text-muted fs-11">
                      Dropdown Item Text
                    </DropdownItem>
                    <DropdownItem disabled className="fs-14">
                      Action (disabled)
                    </DropdownItem>
                    <DropdownItem divider />
                    <DropdownItem
                      onClick={() => {
                        userLogoutAction(dispatch);
                      }}
                      className="fs-12"
                    >
                      Logout
                    </DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>
              </div>
            </Col>
          </Row>
        </Container>
      </header>
    </React.Fragment>
  );
};

export default Header;
